import Swiper from 'swiper/core';
import { Navigation, Autoplay, FreeMode } from 'swiper/modules';

function initSliders() {
  const productSliders = document.querySelectorAll('.js-testimonials-slider');
  if (!productSliders.length) return;

  productSliders.forEach((slider) => {
    const sliderContainer = slider.closest('.js-slider-container');
    const sliderArrows = sliderContainer.querySelector('.js-arrows');
    let navArrows = false;
    if (sliderArrows) {
      const next = sliderArrows.querySelector('.js-arrow-next');
      const prev = sliderArrows.querySelector('.js-arrow-prev');
      navArrows = {
        nextEl: next,
        prevEl: prev,
      };
    }

    new Swiper(slider, {
      modules: [Autoplay, Navigation, FreeMode],
      slidesPerView: 'auto',
      spaceBetween: 16,
      // slidesOffsetAfter: 16,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: navArrows,
      breakpoints: {
        320: {
          slidesOffsetAfter: 0,
        },
        768: {
          slidesOffsetAfter: 16,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initSliders());

if (window.acf?.addAction) {
  const rerender = ($el) => initSliders($el[0] || $el);

  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
